module.exports = __webpack_public_path__ + "static/media/logo_with_text.8a28c078.svg";